var map = {
	"./TechBullion.png": 2306,
	"./about/back.svg": 28794,
	"./about/close.svg": 55094,
	"./about/date.svg": 19260,
	"./about/mission-m.png": 81865,
	"./about/mission.png": 82074,
	"./about/popup-shap.svg": 54334,
	"./about/shap.png": 56935,
	"./about/slide.png": 61994,
	"./about/team/LFG.jpg": 18008,
	"./about/team/brian.png": 68095,
	"./about/team/cp.jpg": 19321,
	"./about/team/cp.png": 87345,
	"./about/team/crypdoebags.jpg": 60580,
	"./about/team/danny.png": 99084,
	"./about/team/paws.png": 61140,
	"./about/team/prash.jpg": 42294,
	"./about/vision-m.png": 76311,
	"./about/vision.png": 15281,
	"./benzinga.png": 85689,
	"./btn-arrow-blue.svg": 8062,
	"./btn-arrow-dark.svg": 30036,
	"./btn-arrow.svg": 73525,
	"./copy.svg": 44924,
	"./digital.png": 10918,
	"./dog-icon.png": 6925,
	"./eth-icon.png": 69380,
	"./g-d-bg.png": 46690,
	"./home/Binance.svg": 84699,
	"./home/Coinbase.svg": 58286,
	"./home/LooksRare.png": 73717,
	"./home/Metamask.svg": 50502,
	"./home/OpenSea.svg": 13039,
	"./home/arrow-blue.svg": 63632,
	"./home/banner.png": 99002,
	"./home/community-bg.png": 52454,
	"./home/copy.svg": 1357,
	"./home/dogcard.png": 93502,
	"./home/down.svg": 32759,
	"./home/earn.png": 43546,
	"./home/king.png": 80254,
	"./home/kudoetokenomics.png": 70186,
	"./home/news/1.webp": 46522,
	"./home/news/2.webp": 37567,
	"./home/news/3.webp": 66407,
	"./home/news/news3details/1.webp": 26981,
	"./home/news/news3details/2.png": 90865,
	"./home/nft.png": 84723,
	"./home/partners/Bitmart.svg": 14974,
	"./home/partners/CMC.svg": 27268,
	"./home/partners/CoinGeko.svg": 69574,
	"./home/partners/Hotbit.svg": 9268,
	"./home/partners/LBANK.svg": 42642,
	"./home/partners/MEXC.svg": 59476,
	"./home/partners/Sandbox.svg": 38686,
	"./home/partners/Uniswap.svg": 26407,
	"./home/partners/ZT.svg": 61908,
	"./home/partners/gate.svg": 52121,
	"./home/partners/opensea.svg": 38835,
	"./home/partners/poloniex.svg": 51979,
	"./home/partners/unknown.svg": 94743,
	"./home/play-btn.svg": 24837,
	"./home/product/1.png": 98734,
	"./home/product/2.png": 3972,
	"./home/product/3.png": 77265,
	"./home/product/4.png": 41557,
	"./home/product/5.png": 80472,
	"./home/product/6.png": 69151,
	"./home/ranger.png": 2052,
	"./home/shap-bg.png": 95447,
	"./home/social-1.svg": 77566,
	"./home/social-2.svg": 72402,
	"./home/social-3.svg": 49101,
	"./home/social-4.svg": 35908,
	"./home/social-5.svg": 17553,
	"./home/social-6.svg": 7300,
	"./home/squar.png": 22012,
	"./home/tokenomic.png": 96058,
	"./home/union.svg": 17292,
	"./home/video.png": 72093,
	"./logo.jpeg": 32498,
	"./logo.svg": 82835,
	"./logo/logo.png": 87445,
	"./logo/logo.svg": 32470,
	"./logo/logo2.svg": 66880,
	"./logo2.jpeg": 1430,
	"./logo2.svg": 95743,
	"./market.png": 28495,
	"./select_arrow.svg": 70993,
	"./staking/info-icon.svg": 59572,
	"./staking/pool-bg.svg": 69814,
	"./staking/popup-bg.png": 92897,
	"./staking/staking.png": 80649,
	"./staking/total-bg1.png": 17676,
	"./staking/total-bg2.png": 60650,
	"./yahoo.png": 6958
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 90990;